export function createFrameClock(fps, durationFrames) {
    return {
        fps,
        durationFrames,
        frameToTime(frame) {
            return frame / fps;
        },
        timeToFrame(time) {
            return Math.max(0, Math.round(time * fps));
        },
        clampFrame(frame) {
            return Math.min(Math.max(0, Math.round(frame)), durationFrames);
        },
        isValidFrame(frame) {
            return frame >= 0 && frame <= durationFrames && Number.isInteger(frame);
        },
        frameCount() {
            return durationFrames;
        },
        lastFrame() {
            return durationFrames;
        },
    };
}
export function framesForSeconds(seconds, fps) {
    return Math.max(0, Math.round(seconds * fps));
}
export function secondsForFrames(frames, fps) {
    return frames / fps;
}
//# sourceMappingURL=frame-clock.js.map